// src/components/TwoFactorAuthPage.js
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { Backdrop, CircularProgress } from '@mui/material';

import { AuthContext } from '../../contexts/auth';

const HOST = process.env.REACT_APP_HOST;

const TwoFactorAuthPage = () => {
  const { login, logout, loading, toggleLoading, setAuth } = React.useContext(AuthContext);
  const [code, setCode] = useState(['', '', '', '', '']);
  const [count, setCount] = useState(0);
  const codeInputs = useRef([]);
  const [phone, setPhone] = useState(localStorage.getItem('tel') || '');
  const errorMessage = 'Erro na validação do código de autenticação.';
  const [countdown, setCountdown] = useState(600);

  React.useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [countdown]);

  const navigate = useNavigate();

//---
  const handlePaste = (e) => {
    e.preventDefault();

    const pasted = e.clipboardData
      .getData('text')
      .replace(/\D/g, '') // remove tudo que não for número
      .slice(0, code.length);

    if (!pasted) return;

    const newCode = [...code];

    pasted.split('').forEach((char, index) => {
      if (index < newCode.length) {
        newCode[index] = char;
      }
    });

    setCode(newCode);

    const nextIndex = pasted.length >= codeInputs.current.length
      ? codeInputs.current.length - 1
      : pasted.length;

    codeInputs.current[nextIndex]?.focus();
  };
//---

  const handleChange = (index, value) => {
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (index < codeInputs.current.length - 1 && value !== '') {
      codeInputs.current[index + 1].focus();
    }
  };

  const handleBackspace = (index, e) => {
    if (e.key === 'Backspace' && index > 0 && code[index] === '') {
      codeInputs.current[index - 1].focus();
    }
  };

  const handleValidation = async () => {
    const codeString = code.join('');

    toggleLoading(true);

    try {
      fetch(`${HOST}/api/authenticate/faVerify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: codeString,
          cnpj: localStorage.getItem('cnpj'),
          carteira: localStorage.getItem('carteira')
        }),
      })
        .then(
          (res) => res.json()
        )
        .then((data) => {
          toggleLoading(false);
          if (data.exec === 'OK') {
            if (data.user.cpf) {
              login(data.user.cpf, data.user.role, data.token);
              navigate('/');
            } else {
              login(data.user.cnpj, data.user.role, data.token);
              navigate('/');
            }
          }
          else {
            alert('Código invalido.');
            setCode(['', '', '', '', '']);
            setCount(counter => counter + 1);
          }
        });
    } catch (err) {
      toggleLoading(false);
      setAuth(false);
      alert(errorMessage);
    }
  };

  return (
    <div className="two-factor-auth">
      <h2>AUTENTICAÇÃO DE DOIS FATORES</h2>
      <p style={{ textAlign: 'center' }}>Insira o código de autenticação enviado para o seu Email .
        <br />
        Se você não receber o código em até {Math.floor(countdown / 60)}:{(countdown % 60) < 10 ? '0' + (countdown % 60) : (countdown % 60)} minutos,
        recarregue a pagina e tente novamente.
      </p>
      <div className="code-input">
        {code.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (codeInputs.current[index] = el)}
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={1}
            value={digit}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, ''); // só números
              handleChange(index, value);
            }}
            onKeyDown={(e) => handleBackspace(index, e)}
            onPaste={handlePaste}   // ✅ AQUI
            style={{
              width: '40px',
              height: '40px',
              textAlign: 'center',
              fontSize: '18px',
              margin: '4px',
              borderRadius: '6px',
              border: '1px solid #007f3d',
            }}
          />
        ))}
      </div>

      <button onClick={handleValidation}>Validar</button>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default TwoFactorAuthPage;
